import { AssetRenderer, Container } from '@/components';
import { Breadcrumbs } from '@/components';
import { type IPageOverviewBanner, SectionThemeKey } from '@/interfaces';
import ButtonGroup from '../ButtonGroup';
import GraphicImg from '../GraphicImg';
import { ResponsiveText } from '../ResponsiveText';
import {
  BannerContainer,
  BannerInnerContainer,
  ButtonGroupWrapper,
  DefaultBannerWrapper,
  HeroAssetWrapper,
  SubText,
  SubTitle,
  Title,
} from './DefaultBanner.styles';

const DefaultBanner: React.FC<IPageOverviewBanner> = ({
  breadcrumbs,
  title,
  subTitle,
  subText,
  subTextMobile,
  priority,
  buttons,
  theme,
  image,
  imageMobile,
  heroAsset,
}) => {
  // One <h1> with the same title on every viewport (only its font size changes via CSS); the subtext may differ on mobile
  const desktopSubText = subText?.trim();
  const mobileSubText = subTextMobile?.trim();

  return (
    <DefaultBannerWrapper sectionTheme={theme || SectionThemeKey.Light}>
      <GraphicImg image={image} imageMobile={imageMobile} priority={priority} />
      <Container style={{ position: 'relative' }}>
        <BannerContainer fullWidth={!heroAsset}>
          <BannerInnerContainer>
            {!!breadcrumbs && <Breadcrumbs {...breadcrumbs} />}
            {subTitle && <SubTitle>{subTitle}</SubTitle>}
            {title && <Title>{title}</Title>}
            {(desktopSubText || mobileSubText) && (
              <SubText>
                <ResponsiveText desktopText={desktopSubText} mobileText={mobileSubText} />
              </SubText>
            )}
            {!!buttons?.length && (
              <ButtonGroupWrapper>
                <ButtonGroup buttons={buttons} />
              </ButtonGroupWrapper>
            )}
          </BannerInnerContainer>

          {heroAsset && (
            <HeroAssetWrapper>
              <AssetRenderer
                asset={heroAsset}
                imageProps={{
                  width: 540,
                  height: 232,
                  decoding: 'sync',
                }}
              />
            </HeroAssetWrapper>
          )}
        </BannerContainer>
      </Container>
    </DefaultBannerWrapper>
  );
};

export default DefaultBanner;
